import { ResetCellsParams } from './types';

const resetCells = (params: ResetCellsParams) => {
  const { cells, changes, value = 0 } = params;

  cells.forEach(cell => {
    if (!cell) {
      return;
    }

    const currentCell = cell;

    currentCell.greaterThan = undefined;
    currentCell.hidden = true;
    currentCell.isRequired = false;
    currentCell.readOnly = true;

    changes.push({ cell: currentCell, value });
  });
};

export default resetCells;
